<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>

    <EditProject
      :project="project"
      v-if="isEditing"
      v-on:project-saved="projectSaved"
      v-on:cancel-edit="cancelEdit"
    />
    <ProjectInfo v-else :project="project" v-on:edit-project="isEditing=!isEditing" />

    <b-card-group deck class="mb-3">
      <b-card class="text-center">
        <i class="fas fa-inbox h1"></i>
        <b-card-title>Izveštaji</b-card-title>
        <b-card-text>Slanje i pregled predatih izveštaja o projektnim aktivnostima.</b-card-text>
        <b-button
          variant="outline-primary"
          :to="{name:'reports', params:{uuid:project.id}}"
        >Detaljnije</b-button>
      </b-card>
      <b-card class="text-center">
        <i class="far fa-folder-open h1"></i>
        <b-card-title>Resursi</b-card-title>
        <b-card-text>Materijali za preuzmianje postavljeni od strane ekspetskog tima.</b-card-text>
        <b-button
          variant="outline-primary"
          :to="{name:'resources', params:{uuid:project.id}}"
        >Detaljnije</b-button>
      </b-card>
      <b-card class="text-center">
        <i class="far fa-newspaper h1"></i>
        <b-card-title>Vesti</b-card-title>
        <b-card-text>Pošaljite vesti o aktivnostima koje će biti objavljene na sajtu granta.</b-card-text>
        <b-button variant="outline-primary" :to="{name:'news', params:{uuid:project.id}}">Detaljnije</b-button>
      </b-card>
      <b-card class="text-center">
        <i class="far fa-calendar-alt h1"></i>
        <b-card-title>Kalendar</b-card-title>
        <b-card-text>Pregled i najava događaja projektnih aktivnosti svih partnera na grantu.</b-card-text>
        <b-button variant="outline-primary" to="/calendar">Detaljnije</b-button>
      </b-card>
    </b-card-group>
  </b-container>
</template>

<script>
import ProjectInfo from "@/components/project/ProjectInfo";
import EditProject from "@/components/project/EditProject";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ProjectInfo,
    EditProject
  },
  data() {
    return {
      isEditing: false
    };
  },
  created() {
    this.getProject()
      .then()
      .catch(err => {
        console.log(err);
      });

    this.$store.commit("setBreadcrumbs", [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" },
        active: true
      }
    ]);
  },
  computed: {
    ...mapGetters({
      breadcrumbs: "breadcrumbs",
      project: "project/data",
      project_title: "project/title"
    })
  },
  methods: {
    ...mapActions({
      getProject: "project/get"
    }),
    projectSaved() {
      this.makeToast(
        "success",
        "Sačuvano!",
        "Detalji projekta " + this.project.title + " su sačuvane."
      );
      this.isEditing = false;
    },
    cancelEdit() {
      this.isEditing = false;
    }
  }
};
</script>
<style>
</style>
